export enum DocumentType {
  CLASS = 'class',
  ARTICLE_LESSON = 'articleLesson',
  VIDEO_LESSON = 'videoLesson',
  RECIPE_LESSON = 'recipeLesson',
}

export enum ParentLabel {
  FEATURED_CLASSES = 'Featured Classes',
  MY_CLASSES = 'My Classes',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
  RECENTLY_FAVORITED = 'Recently Favorited',
  RECOMMENDED_CLASSES = 'Recommended Classes',
  INSTRUCTORS = 'Meet Our Instructors',
  POPULAR_TECHNIQUES = 'Popular Techniques',
}
